var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9998 5.4002V4.2002C2.9998 2.54334 4.34295 1.2002 5.9998 1.2002C7.65665 1.2002 8.9998 2.54334 8.9998 4.2002V5.4002C9.66254 5.4002 10.1998 5.93745 10.1998 6.6002V9.6002C10.1998 10.2629 9.66254 10.8002 8.9998 10.8002H2.9998C2.33706 10.8002 1.7998 10.2629 1.7998 9.6002V6.6002C1.7998 5.93745 2.33706 5.4002 2.9998 5.4002ZM7.7998 4.2002V5.4002H4.1998V4.2002C4.1998 3.20608 5.00569 2.4002 5.9998 2.4002C6.99391 2.4002 7.7998 3.20608 7.7998 4.2002Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.825a8c0e4e24a0b5ca583c6596f61b3e.svg";
export { ForwardRef as ReactComponent };